<template>
  <div id="app">
    <!--<router-view/>-->
    <template v-if="showApp">
      <transition name="fade-left">
        <keep-alive>
          <router-view
            v-if="$route.meta.keepAlive && iWidth != null"
            :class="iWidth > 750 ? 'router-view-750' : 'router-view'"
          >
          </router-view>
        </keep-alive>
      </transition>
      <transition name="fade-left">
        <router-view
          v-if="!$route.meta.keepAlive && iWidth != null"
          :class="iWidth > 750 ? 'router-view-750' : 'router-view'"
        >
        </router-view>
      </transition>
    </template>
    <template v-else>
      <div class="loading-wrap">
        <van-loading type="spinner" vertical>加载中...</van-loading>
      </div>
    </template>
    <div v-if="$store.state.showLoading" class="g_loading">
      <div class="g_loading-box">
        <van-loading vertical>{{ $store.state.showLoadingText }}</van-loading>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getToken,
  getQueryString,
  configApi,
  deepClone,
  getPremissing,
  reLogin,
  getBindToken,
  getCurMeeetInfo,
  initWebSocket
} from "@/utils/common";
import config, { df_avatar } from "@/utils/config";
import { Dialog, Toast } from "vant";
import questionOnly from "@/utils/questionOnly";
export default {
  name: "App",
  data() {
    return {
      iWidth: null,
      showApp: false,
      isInApp: false,
      meetingInfo: {},
      token: ""
    };
  },
  watch: {
    "$store.state.showApp"() {
      this.showApp = this.$store.state.showApp;
    },
    "$store.state.meetingInfo"() {
      this.meetingInfo = this.$store.state.meetingInfo;
    }
  },
  created() {
    this.token = localStorage.getItem("token");
    this.showApp = deepClone(this.$store.state.showApp);
    let currentUrl = window.location.href;
    if (currentUrl.includes("meeting") || currentUrl.includes("pre")) { // 腾讯会议
      this.loadScript(
        "https://cdn.meeting.tencent.com/jssdk/wemeet-js-sdk-1.0.19.js"
      )
        .then(async () => {
          this.isInApp = window.wemeet.app.isTMWebview();
          if (this.isInApp) {
            if (
              getQueryString("auth_code") &&
              localStorage.getItem("loadPage")
            ) {
              let res = await getBindToken(getQueryString("auth_code"));
              if (res) {
                localStorage.setItem("token", res.access_token);
                localStorage.setItem("bind_status", res.bind_status || 0);
                let { name = "mindex", query = {} } = JSON.parse(
                  localStorage.getItem("loadPage")
                );
                localStorage.removeItem("loadPage");
                this.$router.replace({
                  name: name,
                  query: query
                });
                this.getPremise();
              }
              return;
            }
            // 第一次鉴权成功之后再次刷新不再次调取鉴权的接口
            let load_time = parseInt(localStorage.getItem("load_time")) || 0;
            if (
              !load_time ||
              new Date().getTime() / 1000 - load_time > 60 * 10
            ) {
              localStorage.setItem("load_time", new Date().getTime() / 1000);
              if (localStorage.getItem("loadPage"))
                localStorage.removeItem("loadPage");
              if (getToken()) {
                this.getPremise();
              } else {
                this.handleErr("没有token重新跳转");
              }
            } else {
              let { openId } =
                JSON.parse(localStorage.getItem("userInfo")) || {};
              let { meet_id } =
                JSON.parse(localStorage.getItem("meetingInfo")) || {};
              if (openId) {
                if (meet_id) {
                  this.getMeetingInfo(meet_id, openId);
                } else {
                  Toast(
                    "暂未获取meetingInfo：" + JSON.stringify(this.meetingInfo)
                  );
                  this.handleErr();
                }
              } else {
                this.handleErr("没有token重新跳转");
              }
            }
          }else {
            this.$store.commit("changeAppShow", true);
            this.handleEnvData()
          }
        })
        .catch(error => {
          // console.error("Failed to load script:", error);
        });
    } else {
      this.$store.commit("changeAppShow", true);
      this.handleEnvData()
      configApi(function(res) {}, function(err) {});
    }
  },
  methods: {
    handleEnvData() {
      window.wemeet = {
        app: {
          isTMWebview: function() {},
          shareOpenApp: function() {},
          setShareOpenAppConfig: function() {}
        },
        meeting: { getUserInfo: function() {} },
        permission: {
          requestAuth: function() {},
          getUserInfo: function() {},
          agentConfig: function() {}
        }
      };
    },
    loadScript(url) {
      return new Promise((resolve, reject) => {
        let scriptElement = document.createElement("script");
        scriptElement.src = url;
        scriptElement.onload = resolve;
        scriptElement.onerror = reject;
        document.head.appendChild(scriptElement);
      });
    },
    handleErr(err) {
      let { name = "", query = {} } = this.$router.history.current;
      if (!name) name = "home";
      localStorage.setItem(
        "loadPage",
        JSON.stringify({
          name,
          query
        })
      );
      let url =
        this.$router.history.current.fullPath == "/"
          ? "/mindex"
          : this.$router.history.current.fullPath;
      if (localStorage.getItem("userInfo")) localStorage.removeItem("userInfo");
      if (localStorage.getItem("token")) localStorage.removeItem("token");
      if (localStorage.getItem("bind_status"))
        localStorage.removeItem("bind_status");
      setTimeout(() => {
        reLogin("", url);
      }, 10);
    },
    getPremise() {
      let url =
        this.$router.history.current.fullPath == "/"
          ? "/mindex"
          : this.$router.history.current.fullPath;
      getPremissing(url)
        .then(() => {
          window.wemeet.meeting
            .getCurrMeetingInfo()
            .then(resp => {
              let { meetingId, roleType } = resp;
              this.$store.commit("changeMeetingInfo", {
                meet_id: meetingId,
                roleType
              });
              window.wemeet.meeting
                .getUserInfo()
                .then(resp => {
                  let { nickname, avatar = df_avatar, openId } = resp;
                  localStorage.setItem(
                    "userInfo",
                    JSON.stringify({ nickname, avatar, openId })
                  );
                  this.getMeetingInfo(meetingId, openId);
                })
                .catch(err => {
                  Toast("tip2:" + JSON.stringify(err));
                  if (err.code == 10003) {
                    this.handleErr("获取个人信息失败");
                  }
                });
            })
            .catch(err => {
              if (err.code == 10003) {
                this.handleErr("获取会议信息失败");
              }
              Toast("tip2:" + JSON.stringify(err));
            });
        })
        .catch(err => {
          if (err.errcode === 112) {
            this.handleErr("获取鉴权失败");
          } else if (err.sta === -500) {
            this.handleErr("获取鉴权失败-500");
          } else {
            Toast("tip1:" + JSON.stringify(err));
          }
        });
    },
    async getMeetingInfo(meetingId, openId) {
      let res = await getCurMeeetInfo(meetingId);
      if (res) {
        initWebSocket(this.$store.state.meetingInfo.meet_id);
        let {
          meet_admin,
          status = 2,
          time_limit,
          timer_type,
          expend_time
        } = res.data;
        if (!meet_admin && this.meetingInfo.roleType == 1) {
          // 未存储过主持人信息
          let res = await this.updateMeetingOwner(openId);
          if (res) {
            meet_admin = openId;
          }
        }
        this.$store.commit(
          "changeMeetingInfo",
          meet_admin
            ? { status, time_limit, timer_type, expend_time, meet_admin }
            : { status, meet_admin }
        );
        if (meet_admin && status != 2) {
          this.$router.push({ name: "timer" });
        }
        if (localStorage.getItem("fail_count"))
          localStorage.removeItem("fail_count");
        this.$store.commit("changeAppShow", true);
      }
    },

    // 更新会议主持人信息
    updateMeetingOwner(open_id) {
      return new Promise(resolve => {
        questionOnly
          .post("/xcx/ques/v1/meeting/role", {
            access_token: getToken(),
            meet_id: this.meetingInfo.meet_id,
            open_id
          })
          .then(res => {
            if (res.sta == 0) {
              resolve("更新会议主持人");
            } else if (res.sta == -500) {
              this.handleErr("更新会议主持人-500");
            } else {
              Toast(res.msg);
            }
          });
      });
    }
  },
  mounted() {
    // 获取一下url，如果是哈希就强转成history，去掉井号
    var url = window.location.href;
    if (url.indexOf("/#/") != -1) {
      url = url.replace("/#/", "/");
      window.location.href = url;
    }
    var iWidth = document.documentElement.clientWidth;
    // 也就是如果>750,就居中，宽度750，其他情况就100%，保持原来的
    this.iWidth = iWidth;
    var myWidth = document.documentElement.clientWidth;
    config.MyWidth = myWidth;
    if (document.documentElement.clientWidth > 500) myWidth = 500;
    document.getElementsByTagName("html")[0].style.fontSize =
      myWidth / 10 + "px";
    let vid = this.$route.query.vid;
    if (vid) {
      config.Vid = vid;
    }
  },
  destroyed() {}
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #262626;
}
.g_loading {
  height: auto;
  padding: 30px;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 101;
  color: #fff;
}
.g_loading .g_loading-box {
  width: 100px;
  height: 100px;
  background: rgba(77, 77, 77, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.router-view {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: all 0.5s cubic-bezier(0.5, 0, 0.1, 1);
}
.router-view-750 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 500px;
  height: 100%;
  margin: auto;
  transition: all 0.5s cubic-bezier(0.5, 0, 0.1, 1);
}

.fade-left-enter,
.fade-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}

.fade-left-leave-active,
.fade-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
.loading-wrap {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue